var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceidIconBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "xhdpi/icon/FR/grey (26px)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Core",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "In/Out-dashboard",
    transform: "translate(-21.000000, -355.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "side-nav"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4_white-dark",
    transform: "translate(0.000000, 159.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VISAGE",
    transform: "translate(0.000000, 179.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/FR/grey-(26px)",
    transform: "translate(21.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(4.333333, 3.333333)",
    stroke: "#757575"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.515413125,16.75 L16.4411086,16.75 C16.1830433,12.5766498 12.7166037,9.27173913 8.47826087,9.27173913 C4.23991802,9.27173913 0.773478409,12.5766498 0.515413125,16.75 Z",
    id: "Rectangle-3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 8.47826087,
    cy: 4.23913043,
    r: 4.23913043
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.433333333,9.05941988e-14 C0.194025,9.05941988e-14 9.05941988e-14,0.194025 9.05941988e-14,0.433333333 L9.05941988e-14,5 L1,5 L1,1 L5,1 L5,9.05941988e-14 L0.433333333,9.05941988e-14 Z",
    id: "Shape",
    fill: "#757575",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5666667,9.05941988e-14 L21,9.05941988e-14 L21,1 L25,1 L25,5 L26,5 L26,0.433333333 C26,0.194025 25.805975,9.05941988e-14 25.5666667,9.05941988e-14 Z",
    id: "Shape",
    fill: "#757575",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,25 L1,21 L9.05941988e-14,21 L9.05941988e-14,25.5666667 C9.05941988e-14,25.805975 0.194025,26 0.433333333,26 L5,26 L5,25 L1,25 Z",
    id: "Shape",
    fill: "#757575",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,21 L25,25 L21,25 L21,26 L25.5666667,26 C25.805975,26 26,25.805975 26,25.5666667 L26,21 L25,21 Z",
    id: "Shape",
    fill: "#757575",
    fillRule: "nonzero"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceidIconBlack);
export default __webpack_public_path__ + "static/media/faceid_icon_black.f0b3efbb3eed779c8e551d7b345f7e27.svg";
export { ForwardRef as ReactComponent };